function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "0,224 0,245.334 0,266.666 0,288 512,288 512,266.666 512,245.334 512,224 "
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 224,
  width: 64,
  height: 512
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function Svg147Dominica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 512
  }), _ref2, /*#__PURE__*/React.createElement("rect", {
    y: 224,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 21.337
  }), /*#__PURE__*/React.createElement("rect", {
    y: 266.663,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 21.337
  }), _ref3, /*#__PURE__*/React.createElement("rect", {
    x: 224,
    style: {
      fill: "#FFDA44"
    },
    width: 21.326,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.674,
    style: {
      fill: "#F0F0F0"
    },
    width: 21.326,
    height: 512
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 256,
    cy: 256,
    r: 81.619
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M274.596,265.107c-6.071-12.142-13.963-24.449-13.963-24.449s0.196-5.603,0.196-8.942   c0-5.03-4.077-9.107-9.107-9.107c-4.765,0-8.668,3.661-9.067,8.321c-3.746,0.245-6.712,3.352-6.712,7.161   c0,2.769,1.569,5.168,3.864,6.368c1.141-2.669,3.376-4.753,6.141-5.703c0.45,0.37,0.935,0.698,1.451,0.977l1.166,0.559   c0,0-4.326,12.193-4.326,18.745c0,18.416,12.142,24.095,12.142,24.095v0.19l-6.071,6.069h12.142v-12.142l6.071,6.072   C268.58,283.206,280.026,275.967,274.596,265.107z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "256,189.217 258.763,197.72 267.703,197.72 260.47,202.976 263.234,211.478 256,206.224    248.766,211.478 251.53,202.976 244.297,197.72 253.237,197.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "216.746,201.972 223.978,207.226 231.211,201.972 228.449,210.474 235.682,215.729    226.743,215.73 223.979,224.233 221.216,215.73 212.276,215.729 219.509,210.474  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "192.486,235.363 201.425,235.363 204.188,226.861 206.952,235.363 215.891,235.363    208.659,240.618 211.423,249.121 204.188,243.867 196.955,249.12 199.718,240.618  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "192.486,276.637 199.718,271.383 196.955,262.88 204.188,268.134 211.421,262.879    208.659,271.382 215.893,276.637 206.952,276.638 204.188,285.139 201.425,276.637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "216.746,310.028 219.509,301.527 212.275,296.271 221.216,296.271 223.979,287.767    226.743,296.27 235.682,296.27 228.449,301.526 231.211,310.028 223.978,304.774  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "256,322.783 253.237,314.281 244.297,314.281 251.53,309.025 248.766,300.522 256,305.776    263.233,300.522 260.47,309.025 267.703,314.28 258.763,314.281  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "295.254,310.028 288.022,304.774 280.789,310.029 283.551,301.526 276.317,296.271    285.257,296.27 288.02,287.767 290.784,296.271 299.724,296.271 292.491,301.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "319.514,276.637 310.575,276.637 307.812,285.139 305.048,276.638 296.107,276.638    303.341,271.382 300.577,262.88 307.812,268.134 315.044,262.88 312.282,271.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "319.514,235.363 312.282,240.618 315.045,249.12 307.812,243.866 300.578,249.121    303.341,240.618 296.107,235.364 305.048,235.363 307.811,226.861 310.575,235.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "295.254,201.972 292.491,210.474 299.724,215.729 290.784,215.729 288.022,224.233    285.257,215.73 276.317,215.73 283.551,210.474 280.789,201.973 288.022,207.226  "
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg147Dominica);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };